export const determinePageNumber = (path: string | undefined) => {
  if (path) {
    let page = path.split('=').at(-1);
    if (page) return parseInt(page);
  }
};
